import React from "react";
import { useLanguage } from "../../../../contexts";
import { P, useEnergia } from "../engine";
import { ConInstalacion, StatusBadge } from "../common/SectionCommon";
import "../common/common.scss";
import "./Recommendations.scss";

const IMPACTO = { high: ["Brecha mayor", "energy_performance_impact_high"], med: ["Brecha parcial", "energy_performance_impact_med"], low: ["Cumple", "energy_performance_impact_low"] };

// Recomendaciones automáticas, ordenadas por impacto (buildRecommendations del prototipo).
export function Recommendations({ installation }) {
  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;
  const vista = useEnergia(installation);
  return (
    <ConInstalacion installation={installation} vista={vista} t={t}>
      {(f) => {
        const recs = P.buildRecommendations(f);
        return (
          <div className="ep-screen">
            <h3 className="ep-screen__title">{t("energy_performance_recs_title")}</h3>
            <p className="ep-screen__intro">{t("energy_performance_recs_intro")}</p>
            {!recs.length && <p className="ep-section__note">{t("energy_performance_recs_none")}</p>}
            {recs.map((r, i) => {
              const [estado, k] = IMPACTO[r.impact] || IMPACTO.med;
              return (
                <div className={`ep-rec ep-rec--${r.impact}`} key={i}>
                  <div className="ep-rec__top"><span>{r.origen}</span><StatusBadge estado={estado}>{t(k)}</StatusBadge></div>
                  <div>{r.text}</div>
                </div>
              );
            })}
          </div>
        );
      }}
    </ConInstalacion>
  );
}
